import f from '../../shared/functions.js'



class Purchases {
	constructor(core){

		this.core = core
		this.products = []
		this.availableProducts = {}
		this.ownedCache = null
        
		this.initStore()
	}

	initStore = function(){
		if (typeof CdvPurchase != 'undefined' && f.isios()){

            this.available = true
            this.store = CdvPurchase.store
            this.ProductType = CdvPurchase.ProductType
            this.Platform = CdvPurchase.Platform

			this.availableProducts = {
				'app.snippity.subscription.common.31' : {
					type: this.ProductType.PAID_SUBSCRIPTION,
					id: 'app.snippity.subscription.common.31',
					platform: this.Platform.APPLE_APPSTORE,
					features : [{
						name : 'news',
						id : 1
					},{
						name : 'lessons',
						id : 18
					}]
				},
				'app.snippity.subscription.common.365' : {
					type: this.ProductType.PAID_SUBSCRIPTION,
					id: 'app.snippity.subscription.common.365',
					platform: this.Platform.APPLE_APPSTORE,
					features : [{
						name : 'news',
						id : 1
					},{
						name : 'lessons',
						id : 18
					}]
				}
			}

            this.store.register(_.map(this.availableProducts, (ap) => {
				return {
					type : ap.type,
					platform : ap.platform,
					id : ap.id
				}
			}))

			this.store.initialize([{
				platform: this.Platform.APPLE_APPSTORE,
				options: {
					needAppReceipt: true,
				}
			}])

			this.store.getApplicationUsername = () => {
				return this.core.user.info.userinfo.id
			}

      		this.store.when().productUpdated(() => {
				this.updateState()
			}).approved(() => {
				this.updateState()
			});
      	}
	}

	onResume = function(){
		if (this.store){
			this.store.restorePurchases()
		}
	}

	updateState = function(){

		if (this.store){

			this.core.store.commit('cdvproducts', this.store.products)
			this.products = this.store.products

			var owned = _.find(this.store.products, (p) => {
				if(p.owned) return true
			})

			if (owned){
				this.core.user.cdvOwned(owned)
				this.ownedCache = owned
			}
		}

		
	}

	checkFeatures = function(features){

		if(this.available){
			var owned = _.find(this.core.store.state.cdvproducts, (p) => {
				if(p.owned) return true
			}) || this.ownedCache

			if(owned){
				var infofeatures = this.availableProducts[owned.id]?.features || []

				var f = _.find(features, (f) => {
					return _.find(infofeatures, (ff) => {
						return f == ff.name || f == ff.id
					})
				})

				return f ? true : false
			}
		}
		
		return false
	}

	owned = function(){

		if(this.available){
			var owned = _.find(this.products, (p) => {
				if(p.owned) return true
			})

			if(owned){
				return true
			}
		}
		
		return false
	}

    notify = function(transaction){
		console.log("notify", transaction)
    }
    
	buy = function(productId, offerId){

		if(!this.store) return Promise.reject('failed');

		var product = this.store.get(productId);
		
		if(!product) {
			return Promise.reject('productnotfound');
		}

		var offer = product.getOffer(offerId)

		if(!offer) {
			return Promise.reject('offernotfound');
		}

		return offer.order().then(error => {

			if (error) {
				if (error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
					return Promise.reject('cancelled');
				}
				else {
					return Promise.reject('failed');
				}
			}

			else{
				return Promise.resolve()
			}
		});
	}

}

export default Purchases


/*

document.addEventListener('deviceready', onDeviceReady);

var myProduct;

function onDeviceReady() {
  const {store, ProductType, Platform} = CdvPurchase;
  refreshUI();
  store.register([{
    type: ProductType.CONSUMABLE,
    id: 'my_product',
    platform: Platform.TEST,
  ]});
  store.when()
    .productUpdated(refreshUI)
    .approved(finishPurchase);
  store.initialize([Platform.TEST]);
}

function finishPurchase(transaction) {
  localStorage.goldCoins = (localStorage.goldCoins | 0) + 10;
  transaction.finish();
  refreshUI();
}

function refreshUI() {
  const {store, ProductType, Platform} = CdvPurchase;
  myProduct = store.get('my_product', Platform.TEST);
  const myTransaction = store.findInLocalReceipts(myProduct);
  const button = `<button onclick="myProduct.getOffer().order()">Purchase</button>`;

  document.getElementsByTagName('body')[0].innerHTML = `
  <div>
    <pre>
      Gold: ${localStorage.goldCoins | 0}

      Product.state: ${myTransaction ? myTransaction.state : ''}
             .title: ${myProduct ? myProduct.title : ''}
             .descr: ${myProduct ? myProduct.description : ''}
             .price: ${myProduct ? myProduct.pricing.price : ''}

    </pre>
    ${myProduct.canPurchase ? button : ''}
  </div>`;
}

*/